import React from "react";
import { Icons } from "./types";

export const SvgIcon = <T extends {}>({
  iconName, alternativeText, className, hideFromScreenReaders
}: {
  iconName: T | Icons ;
  alternativeText?: string;
  hideFromScreenReaders?: boolean;
  className?: string;
}) => {

  const shouldBeHiddenFromScreenReaders = hideFromScreenReaders && { 'aria-hidden': true, focusable: false };
  return (
    <svg className={className} role="img" aria-label={alternativeText} {...shouldBeHiddenFromScreenReaders}>
      <use xlinkHref={`/dist/spritemap.svg#sprite-${iconName}`} />
    </svg>
  );
}
